function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.998 2.25a.958.958 0 00-.513.151L3 4.599H1c-.552 0-1 .469-1 1.049v4.204c0 .58.448 1.049 1 1.049h2l3.485 2.198a.958.958 0 00.513.151C7.52 13.25 8 12.813 8 12.198V3.302c0-.615-.48-1.052-1.002-1.052M6 5.071v5.358L4.066 9.21l-.488-.309H2V6.599H3.578l.488-.309L6 5.071",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.06 2.765l1.47-1.47A.749.749 0 104.47.235L3 1.704 1.53.234a.75.75 0 00-1.06 1.06l1.47 1.47-1.47 1.47a.749.749 0 101.06 1.06L3 3.827l1.47 1.469a.746.746 0 001.06 0 .749.749 0 000-1.06l-1.47-1.47z",
  fill: "#000",
  mask: "url(#mask-2)",
  transform: "translate(10 5)"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgComponent;